(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/utils/wheel.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/utils/wheel.js');

'use strict';

const engineUtils = svs.racing.gameEngine.utils.engine;
const isBaseSet = value => (value & 1) > 0; 
const isExtraSet = value => (value & 1 << 1) > 0; 
const toggleSelection = (value, isBase) => {
  const bitmask = 1 << (isBase ? 0 : 1);
  return bitmask & value ^ bitmask;
};
const getAutomaticReserve = participants => participants.reduce((prev, curr) => prev.oddsLatest < curr.oddsLatest ? prev : curr, {});
const rowToPositions = (row, numPositions, conditionFn) => {
  const positions = numPositions > 0 ? new Array(numPositions) : [];
  row.forEach((value, index) => {
    if (engineUtils.isPosition(value) && (conditionFn ? conditionFn(value) : true)) {
      if (isBaseSet(value)) {
        if (!positions[0]) {
          positions[0] = [];
        }
        positions[0].push(engineUtils.indexToPosition(index));
      } else if (isExtraSet(value)) {
        if (!positions[1]) {
          positions[1] = [];
        }
        positions[1].push(engineUtils.indexToPosition(index));
      }
    }
  });

  for (let i = 0; i < positions.length; i++) {
    positions[i] = positions[i] || undefined;
  }
  return positions;
};
const isBaseFull = (row, numPositions) => {
  const maxNumberOfBaseHorses = numPositions - 1;
  return engineUtils.countPositions(row, value => engineUtils.isPosition(value) && isBaseSet(value)) === maxNumberOfBaseHorses;
};
svs.racing.gameEngine.utils.wheel = {
  getAutomaticReserve,
  isBaseSet,
  isExtraSet,
  toggleSelection,
  rowToPositions,
  isBaseFull
};

 })(window);